import { Button } from '@/components/shared/buttons/button';
import { ButtonGroup } from '@/components/shared/buttons/button-group';
import { Container } from '@/components/shared/layout/container';
import { styled } from '@/stitches.config';
import { IHeadline, IMy24Theme } from '@/types/shared';
import { ITracking } from '@/types/tracking';

const StyledHeadlineButton = styled('div', {});

type IProps = React.ComponentProps<typeof StyledHeadlineButton> &
  IHeadline & {
    children?: React.ReactNode;
    theme?: IMy24Theme;
    tracking?: ITracking;
  };

const HeadlineButton: React.FunctionComponent<IProps> = (props: IProps) => {
  return (
    <>
      {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
      {/* @ts-ignore */}
      {props?.buttons?.length > 0 && (
        <Container
          css={{
            '@lg': {
              display: 'none',
            },
          }}
        >
          <ButtonGroup
            justify="center"
            css={{
              marginTop: '$space-10',
            }}
          >
            {props?.buttons?.map((button, i) => (
              <Button
                key={i}
                href={button?.url}
                target={button?.target}
                border={button?.border}
                label={button?.label}
                icon={button?.icon}
                variant={button?.color}
                size={button?.size}
                isMinWidth={button?.isMinWidth}
                tracking={{
                  dataTrack: props?.tracking?.dataTrack as string,
                  dataTrackSection: props?.tracking?.dataTrackSection,
                  dataTrackText: button?.label,
                  dataTrackUrl: button?.url,
                  dataTrackValue: props?.tracking?.dataTrackValue,
                }}
                test={{
                  dataTest: `headline_ctaButton_${i + 1}`,
                }}
              />
            ))}
          </ButtonGroup>
        </Container>
      )}
    </>
  );
};

HeadlineButton.displayName = 'SharedMY24HeadlineButton';
export default HeadlineButton;
